import { call, put, takeLatest } from "redux-saga/effects"
import { GET_EVOLUTION_MEASURE_WATCHER } from "./constants"

import {
  getEvolutionMeasureFailed,
  getEvolutionMeasureSuccess,
} from "./actions"
import Axios from "axios"
import { LOCAL_TOKEN } from "../../../utils/storage"
import { validate } from "../../../utils/functions"

function getEvolutionMeasureApi(payload) {
  const segmentParam = !validate.empty(payload.id_segment)
    ? `&id_segment=${payload.id_segment}`
    : ""
  return Axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${payload.idMeasure}/evolution?f${segmentParam}`,
    params: { id_division: payload.idDivision, id_segment: payload.idSegment },
  })
}

export function* getEvolutionMeasureSaga(action) {
  try {
    const { data: evolutionData } = yield call(
      getEvolutionMeasureApi,
      action.payload
    )
    yield put(getEvolutionMeasureSuccess(evolutionData))
  } catch (e) {
    console.log(
      "🚀 ~ file: saga.js ~ line 150 ~ function*getEvolutionMeasureSaga ~ e",
      e
    )
    yield put(getEvolutionMeasureFailed())
  }
}

// Individual exports for testing
export default function* widgetResumeSaga() {
  yield takeLatest(GET_EVOLUTION_MEASURE_WATCHER, getEvolutionMeasureSaga)
}
